import React from 'react';
import { Button } from '../components/ui/button';
import { ArrowUpRight, Heart, Music2, Mail, Play } from 'lucide-react';
import { site } from '../data/mock';
import { useI18n } from '../i18n/I18nProvider';

export function Give() {
  const { t } = useI18n();
  return (
    <section id="give" className="relative py-24 lg:py-32 bg-[#1f3a2a] text-[#f5efe3]">
      <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
        <span className="text-[#d4a63d] text-xs uppercase tracking-wider-xtra font-medium">{t.give.eyebrow}</span>
        <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-[1.05]">{t.give.title_1} <span className="italic text-[#e8c87a]">{t.give.title_2}</span></h2>
        <p className="mt-6 text-[#f5efe3]/80 text-lg leading-relaxed">{t.give.sub}</p>
        <div className="mt-10 flex justify-center">
          <Button asChild className="bg-[#d4a63d] hover:bg-[#b88a2a] text-[#1f3a2a] rounded-full h-12 px-7 font-medium">
            <a href={site.cashApp} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2">{t.give.cta} <ArrowUpRight size={18} /></a>
          </Button>
        </div>
        <p className="mt-6 text-[#d4a63d]/90 text-sm inline-flex items-center gap-2 justify-center"><Heart size={14} /> {t.give.thanks}</p>
      </div>
    </section>
  );
}

export function Footer() {
  const { t } = useI18n();
  return (
    <footer className="bg-[#1a3225] text-[#f5efe3] pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-3 gap-10">
        <div>
          <span className="inline-flex items-center justify-center rounded-xl bg-[#f5efe3] px-3 py-2">
            <img src="/planted-logo.png" alt="Planted Ministries" className="h-20 w-auto" />
          </span>
          <p className="mt-5 text-[#f5efe3]/70 text-sm leading-relaxed max-w-xs">{t.footer.about}</p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-wider-xtra text-[#d4a63d] font-medium">{t.footer.join}</h4>
          <ul className="mt-5 space-y-3 text-sm text-[#f5efe3]/80">
            <li>{t.footer.when}</li>
            <li>{t.footer.lineup}</li>
            <li>{t.footer.coffee}</li>
            <li><a href="#rsvp" className="link-underline inline-flex items-center gap-1">{t.footer.rsvpLink}</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-wider-xtra text-[#d4a63d] font-medium">{t.footer.connect}</h4>
          <ul className="mt-5 space-y-3 text-sm text-[#f5efe3]/80">
            <li><a href={`mailto:${site.email}`} className="inline-flex items-center gap-2 link-underline"><Mail size={14} /> {site.email}</a></li>
            <li><a href={site.youtube} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 link-underline"><Play size={14} /> {t.footer.channel}</a></li>
            <li><span className="inline-flex items-center gap-2"><Music2 size={14} /> {site.tiktok}</span></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-14 pt-6 border-t border-[#f5efe3]/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#f5efe3]/60">
        <span>© {new Date().getFullYear()} Planted Ministries. {t.footer.rights}</span>
        <span className="inline-flex items-center gap-1">{t.footer.planted} <Heart size={12} className="text-[#d4a63d]" /> {t.footer.forCity}</span>
      </div>
    </footer>
  );
}
